import { render, staticRenderFns } from "./AIChatNavbar.vue?vue&type=template&id=1b457fca&"
import script from "./AIChatNavbar.vue?vue&type=script&lang=js&"
export * from "./AIChatNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports